module.exports = __webpack_public_path__ + "img/partner_banner.f0a9668f.png";